import request from '@/utils/request.js'

/** 查询登录 */
export const genScanQrKey = () =>{
  return request({
    url: `/portal/web/genScanQrKey`,
    method: "get"
  });
}

/** 检查二维码登录状态 */
export const loginByKey = (data) =>{
  return request({
    url: `/portal/web/auth/portalUser/loginByKey`,
    method: "post",
    data
  });
}

/** 检查二维码登录状态 */
export const checkCaptcha = (data) =>{
  return request({
    url: `/portal/web/checkCaptcha`,
    method: "post",
    data
  });
}

/** 获取公司信息 */
export const getCompanyUserInfo = () =>{
  return request({
    url: `/portal/web/company/user/getCompanyUserInfo`,
    method: "get"
  });
}

/** 获取个人信息 */
export const getTalentUser = () =>{
  return request({
    url: `/portal/web/talent/info/getTalentUser`,
    method: "get"
  });
}

/** 登录 */
export const loginByCode = (data) =>{
  return request({
    url: `/portal/web/auth/portalUser/loginByCode`,
    method: "post",
    data
  });
}

/** 登录 */
export const getCode = (data) =>{
  return request({
    url: `/portal/web/auth/portalUser/getSmsCode`,
    method: "post",
    data
  });
}

/** 登录 */
export const getCountryPhone = () =>{
  return request({
    url: `/portal/web/countryPhone/getList`,
    method: "get"
  });
}

/** 广告语 */
export const getAdvertisingLeaflet = () =>{
  return request({
    url: `/portal/web/agreement/advertisingLeaflet`,
    method: "get"
  });
}